import { TabletQuerySelectors } from "../types/index-type";


export const initQueryselectorTablet = (): TabletQuerySelectors => {
  const body = document.querySelector<HTMLElement>("body");
  const grid = document.querySelector<HTMLElement>(".grid");
  const sideMenu = document.querySelector<HTMLElement>(".sidebar");
  const sideBarButton = document.querySelector<HTMLElement>(".opcl-button");
  const main = document.querySelector<HTMLElement>(".main");
  const page = document.querySelector<HTMLElement>(".page");
  const codeArticle = document.querySelectorAll<HTMLElement>(".code__article");

  return {
    body,
    grid,
    sideMenu,
    sideBarButton,
    main,
    page,
    codeArticle,
  };
};
